import { RootReducerState } from "../reducers";

export const pushsSelector = (state: RootReducerState) => {
  return state.pushs;
};
